"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RadioTab = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _reduxForm = require("redux-form");
var _commonComponent = require("../../../propTypes/commonComponent");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _dataTestAttributeHelper = require("../../../helpers/dataTestAttributeHelper");
require("./APRadioTab.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var RadioTab = exports.RadioTab = function RadioTab(props) {
  var items = props.items,
    input = props.input,
    baseClass = props.baseClass,
    customClass = props.customClass,
    styleName = props.styleName,
    onClick = props.onClick,
    value = props.value,
    defaultValue = props.defaultValue;
  var baseClasses = (0, _cssClassesHelper.getBEMClasses)(baseClass);
  var customClasses = (0, _cssClassesHelper.getBEMClasses)(customClass);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames2["default"])('btn-group btn-group-toggle', baseClasses(), customClasses('rt-wrapper')),
    "data-toggle": "buttons"
  }, items.map(function (item) {
    var currentValue = input ? input.value : value;
    var inputValueIsSet = currentValue || typeof currentValue === 'boolean';
    var checked = item.value === (inputValueIsSet ? currentValue : defaultValue);
    return /*#__PURE__*/_react["default"].createElement("label", {
      title: item.title ? item.title : item.text,
      className: (0, _classnames2["default"])('btn', getLabelClass(baseClasses, 'label', item.styleName || styleName, checked), getLabelClass(customClasses, 'rt-label', item.styleName || styleName, checked), "".concat(item.disabled ? 'disabled' : '')),
      key: item.value,
      onClick: onClick,
      "data-test": (0, _dataTestAttributeHelper.getDataTestAttribute)(item, 'text')
    }, /*#__PURE__*/_react["default"].createElement("input", _extends({
      type: "radio",
      id: item.value.toString()
    }, input, {
      checked: checked,
      value: item.value,
      onClick: item.onClick,
      disabled: item.disabled,
      onBlur: function onBlur(e) {
        return e.preventDefault();
      },
      onChange: function onChange(e) {
        var value = typeof item.value === 'boolean' ? e.target.value === 'true' : e.target.value;
        input ? input.onChange(value) : onClick(value);
      }
    })), item.text);
  }));
};
var getLabelClass = function getLabelClass(bem, element, styleName, isChecked) {
  return bem({
    element: element,
    modifiers: (0, _classnames2["default"])(styleName, _defineProperty({
      checked: isChecked
    }, "checked-".concat(styleName), isChecked))
  });
};
var itemType = _propTypes["default"].shape({
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]).isRequired,
  text: _propTypes["default"].string.isRequired,
  dataTest: _propTypes["default"].string
});
RadioTab.propTypes = {
  items: _propTypes["default"].arrayOf(itemType).isRequired,
  baseClass: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]),
  styleName: _commonComponent.styleNamePropType
};
RadioTab.defaultProps = {
  baseClass: 'ap-radio-tab',
  styleName: _commonComponent.styleNames.general
};
var APRadioTab = function APRadioTab(props) {
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
    component: RadioTab
  }, props));
};
var _default = exports["default"] = APRadioTab;